import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDeleteApiResponse } from "../../utils/api.types";
import { ISwitchAccount, IUserEmailSearch, IUserInviteToken } from "../../utils/auth.types";
import axios from "../../utils/axios";

import {
    ISupplierDetails,
    ISupplierDetailsResponse,
    ISupplierFormInputs,
    ISupplierUpdatePayload,
    ISuppliersList,
} from "../../utils/supplier.types";
import { CustomerFetch } from "../../utils/customer.types";

/**
 * Fetch Suppliers async thunk.
*/
export const fetchSuppliers = createAsyncThunk(
    'account/fetchSuppliers',
    async ({accountId, params} : CustomerFetch): Promise<ISuppliersList> => {
        let queryParam = (params) ? `${params}`: ''
        const response = await axios.get(`/api/v1/suppliers/${accountId}?${queryParam}`);
        return response.data;
    }
);

/**
 * Fetch suppliers by user id async thunk.
*/
export const fetchSupplierById = createAsyncThunk(
    'account/fetchSupplierById',
    async (id: string): Promise<ISupplierDetails> => {
        const response = await axios.get(`api/v1/suppliers/single/${id}`);

        return response.data.suppliers;
    }
);








